// React
import { useEffect } from 'react'

// React Router Dom
import { useLocation, useHistory } from 'react-router-dom'

// MRL
import { observer } from 'mobx-react-lite'

// Components
import { useSharedUserInfoAlert } from 'components'
import { Route } from './Route'
import { Authorize } from './Authorize'

// i18n
import { useTranslation } from 'react-i18next'

// Constant
import { PERSONAL_DATA_URL, COMMON_URL } from 'constant/url.constant'

// Utils
import { messageUtils_destroy, messageUtils_warning } from 'utils/common/message.utils'

// Custom Hook
import { useAuth } from 'hooks'

const EntryPoint = observer(() => {
  // Hook
  const { t } = useTranslation()
  const history = useHistory()
  const { auth_persisted } = useAuth()
  const { pathname } = useLocation()
  const { renderDescription } = useSharedUserInfoAlert()

  // Reset the nav to always go to the top
  useEffect(() => {
    const unListen = history.listen(() => {
      window.scrollTo(0, 0)
    })
    return () => {
      unListen()
    }

    // eslint-disable-next-line
  }, [])

  // Do when user navigating between route
  useEffect(() => {
    if (
      !auth_persisted?.auth_authenticatedUser?.isValidated &&
      auth_persisted?.auth_isAuthenticated &&
      ![PERSONAL_DATA_URL.PROFILE, COMMON_URL.NOT_FOUND].includes(pathname)
    ) {
      messageUtils_destroy()
      messageUtils_warning(t('auth.title.accountInformation'), {
        duration: 0,
        description: renderDescription(),
      })

      if (!auth_persisted?.auth_accessToken) {
        messageUtils_destroy()
      }
    }

    // eslint-disable-next-line
  }, [pathname, auth_persisted])

  return (
    <>
      {/* Authorize - For Handling Authorization When User Came For The First Time or When User Hard Reload The App */}
      <Authorize />

      {/* App Route */}
      <Route />
    </>
  )
})

export { EntryPoint }

// stag